import React from "react";
import { Thermometer, Clock, Utensils, Flame, ArrowLeft } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HomeServingTips() {
  const steps = [{
    title: "הכנה מוקדמת",
    description: "מומלץ להוציא את הבשר מהמקרר כ-30 דקות לפני החימום, כדי שיגיע לטמפרטורת החדר וישמור על עסיסיות.",
    icon: <Clock className="w-8 h-8 text-primary" />
  }, {
    title: "חימום בתנור",
    description: "חממו תנור ל-160 מעלות. עטפו את הנתח בנייר כסף והכניסו לחימום של כ-15-20 דקות עד שהבשר חם.",
    icon: <Flame className="w-8 h-8 text-primary" />
  }, {
    title: "חיתוך נכון",
    description: "הניחו לבשר לנוח דקה לאחר החימום. פרסו תמיד נגד כיוון הסיבים לקבלת ביס רך ונימוח במיוחד.",
    icon: <Utensils className="w-8 h-8 text-primary" />
  }, {
    title: "הגשה ורטבים",
    description: "הגישו מיד כשהבשר חם. זה הזמן להוסיף את הרטבים המיוחדים שלנו ולשלב עם התוספות הטריות.",
    icon: <Thermometer className="w-8 h-8 text-primary" />
  }];
  return <section id="טיפים-להגשה-בבית" className="dark bg-secondary text-secondary-foreground py-20 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-primary rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-primary font-sans tracking-tight">
            המדריך לחימום והגשה בבית
          </h2>
          <p className="text-lg md:text-xl text-secondary-foreground/80 leading-relaxed">
            כדי שתיהנו מחוויית SMOKE & GO מושלמת גם בבית, הכנו עבורכם מספר טיפים פשוטים שיבטיחו שהבשר יישאר עסיסי ומלא טעם.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {steps.map((step, i) => <Card key={i} data-index={i} className="bg-card/50 border-border/50 backdrop-blur-sm hover:bg-card/80 transition-colors duration-300 h-full">
              <CardHeader className="pb-2">
                <div className="w-14 h-14 rounded-full bg-background/50 flex items-center justify-center mb-4 border border-border/50 shadow-sm">
                  {step.icon}
                </div>
                <CardTitle className="text-xl font-bold text-foreground">
                  {i + 1}. {step.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base text-muted-foreground leading-relaxed">
                  {step.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        <div className="text-center">
          <Button asChild size="lg" className="text-lg px-8 py-6 h-auto shadow-lg hover:shadow-primary/20">
            <Link to="tel:+9725052770606">להזמנה לחצו כאן<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-left mr-2 w-5 h-5" aria-hidden="true"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg></Link>
          </Button>
          <p className="mt-4 text-sm text-muted-foreground">
            * זמני החימום עשויים להשתנות בהתאם לסוג התנור וגודל הנתח
          </p>
        </div>
      </div>
    </section>;
}